import { render } from "./index.vue?vue&type=template&id=235c987a&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=235c987a&lang=less&scoped=true"

import exportComponent from "/builds/toyota/bo/merchant-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-235c987a"]])

export default __exports__